import { getContext, store } from '@wordpress/interactivity';

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

store('mediapress/slider', {
  actions: {
    init() {
      const ctx = getContext();
      const id = ctx?.id;
      const config = ctx?.config ? JSON.parse(ctx?.config) : {};

      const sliderEl = document.querySelector(`.swiper.slider-${id}`);
      if (sliderEl) {
        if (config.pagination) {
          const paginationDiv = document.createElement('div');
          paginationDiv.className = 'swiper-pagination';
          sliderEl.appendChild(paginationDiv);
        }

        if (config.navigation) {
          const prevBtn = document.createElement('div');
          prevBtn.className = 'swiper-button-prev';
          sliderEl.appendChild(prevBtn);

          const nextBtn = document.createElement('div');
          nextBtn.className = 'swiper-button-next';
          sliderEl.appendChild(nextBtn);
        }
      }

      new Swiper(`.swiper.slider-${id}`, config);
    },
  },
});
